
import React, { PureComponent } from 'react'
import { Button, Modal, Col, Row, Form } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import InputText from '../../../../components/commons/form/InputText'
import InputSelect from '../../../../components/commons/form/InputSelect'
import InputNumber from '../../../../components/commons/form/InputNumber'
import SaleRequestFields from '../../../../components/dossiers/common/saleRequestFields/SaleRequestFields'
import { purchaseTypesVn } from '../../../../constants/dossier/purchase/purchaseTypes'
import { permissions } from '../../../../constants/backendIds'
import commonRegExp from '../../../../util/commonRegExp'
import { modelLength } from '../../../../constants/dossier/common/vehicle'
import { handleKeyDown } from '../../../../util/utils'

class OrderModal extends PureComponent {
  constructor () {
    super()
    this.state = {
      purchaseType: null
    }
    this.required = this.required.bind(this)
  }

  submitOrder (values) {
    this.props.actions.saveOrder(values, this.props.dossierId, false, this.props.dossierType)
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (!this.props.showModal && nextProps.showModal) {
      this.props.actions.fetchOrder()
      this.props.validate()
    }
  }

  required (value) {
    return (value || value === 0) && value !== ''
      ? undefined : this.props.t('GLOBAL.FORMS.REQUIRED')
  }

  onBrandIdChanges (brandId) {
    this.props.actions.resetCarlineCombo()
    this.props.actions.resetCatalogueCombo()
    this.props.actions.resetColorCombo()
    this.props.actions.resetTapestryCombo()
    this.props.actions.fetchCarlineCombo(brandId)
  }

  onCarlineIdChanges (carlineId) {
    this.props.actions.resetColorCombo()
    this.props.actions.resetTapestryCombo()
    if (!carlineId) {
      this.props.actions.resetCatalogueCombo()
    }
    this.props.actions.fetchCatalogueCombo(carlineId)
  }

  onCatalogueIdChanges (catalogueId) {
    if (this.props.formValues.modelId && catalogueId) {
      this.props.actions.fetchOrderCatalogueModel(catalogueId, this.props.formValues.modelId)
      this.props.actions.fetchColorCombo(catalogueId, this.props.formValues.modelId)
      this.props.actions.fetchTapestryCombo(catalogueId, this.props.formValues.modelId)
    } else {
      this.props.actions.resetColorCombo()
      this.props.actions.resetTapestryCombo()
      this.props.change('model', null)
    }
  }

  onModelIdChanges (modelId) {
    if (modelId && this.props.formValues.catalogueId) {
      this.props.actions.fetchOrderCatalogueModel(this.props.formValues.catalogueId, modelId)
      this.props.actions.fetchColorCombo(this.props.formValues.catalogueId, modelId)
      this.props.actions.fetchTapestryCombo(this.props.formValues.catalogueId, modelId)
    } else {
      this.props.actions.resetColorCombo()
      this.props.actions.resetTapestryCombo()
      this.props.change('model', null)
    }
  }

  render () {
    const {
      t, handleSubmit, readOnlyFields, showOrderModal, combos: {
        brandCombo, fuelCombo, entityTransferCombo, purchaseTypeVnCombo, carlineCombo,
        catalogueCombo, modelCombo, colorCombo, tapestryCombo
      },
      actions: { closeOrderModal }, purchaseOrderExetendedMode, order
    } = this.props

    const tKey = 'DOSSIER_COMPONENTS.ORDER.'
    return (
      <Modal id='OrderModal' className="_nf" show={showOrderModal} onHide={closeOrderModal}>
        <Form autoComplete="off" onSubmit={handleSubmit(this.submitOrder.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Header closeButton>
            <Modal.Title>{t(`${tKey}ORDER`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row style={{ zIndex: 2 }} className='fieldsContainer'>
              <Field
                component={InputSelect}
                colWidth={25} // 25, 33, 50, 75, 100 default=25
                id="brandIdOrder"
                name="brandId"
                controlLabel={t(`${tKey}BRAND`)}
                placeholder={t(`${tKey}BRAND`)}
                options={brandCombo}
                valueKey="id"
                labelKey="value"
                disabled={readOnlyFields}
                validate={this.required}
                onInputChange={this.onBrandIdChanges.bind(this)}
              />
              {this.props.fieldsConfiguration?.carlineId && this.props.fieldsConfiguration.carlineId.permission !== permissions.hidden && (
                <Field
                  component={InputSelect}
                  colWidth={25} // 25, 33, 50, 75, 100 default=25
                  id="carlineIdOrder"
                  name="carlineId"
                  controlLabel={t(`${tKey}CARLINE`)}
                  placeholder={t(`${tKey}CARLINE`)}
                  valueKey="id"
                  labelKey="value"
                  options={carlineCombo}
                  disabled={carlineCombo.length === 0 || readOnlyFields}
                  onInputChange={this.onCarlineIdChanges.bind(this)}
                  menuPlacement="auto"
                />)}
              {this.props.fieldsConfiguration?.carline && this.props.fieldsConfiguration.carline.permission !== permissions.hidden && (
                <Field
                  component={InputText}
                  id="carlineOrder"
                  name="carline"
                  controlLabel={t(`${tKey}CARLINE`)}
                  placeholder={t(`${tKey}CARLINE`)}
                  disabled={readOnlyFields}
                  validate={this.required}
                />)}
              {this.props.fieldsConfiguration?.catalogueId && this.props.fieldsConfiguration.catalogueId.permission !== permissions.hidden && (
                <Field
                  component={InputSelect}
                  id="catalogueIdOrder"
                  name="catalogueId"
                  controlLabel={t(`${tKey}CATALOGUE`)}
                  placeholder={t(`${tKey}CATALOGUE`)}
                  valueKey="id"
                  labelKey="value"
                  options={catalogueCombo}
                  disabled={catalogueCombo.length === 0 || readOnlyFields }
                  onInputChange={this.onCatalogueIdChanges.bind(this)}
                  menuPlacement="auto"
                />)}
              {this.props.fieldsConfiguration?.catalogue && this.props.fieldsConfiguration.catalogue.permission !== permissions.hidden && (
                <Field
                  component={InputText}
                  id="catalogueOrder"
                  name="catalogue"
                  controlLabel={t(`${tKey}CATALOGUE`)}
                  placeholder={t(`${tKey}CATALOGUE`)}
                  disabled={readOnlyFields}
                  validate={this.required}
                />)}
              {this.props.fieldsConfiguration?.modelId && this.props.fieldsConfiguration.modelId.permission !== permissions.hidden && (
                <Field
                  component={InputSelect}
                  id="modelIdOrder"
                  name="modelId"
                  controlLabel={t(`${tKey}MODEL_YEAR`)}
                  placeholder={t(`${tKey}MODEL_YEAR`)}
                  valueKey="id"
                  labelKey="value"
                  options={modelCombo}
                  disabled={modelCombo.length === 0 || readOnlyFields }
                  onInputChange={this.onModelIdChanges.bind(this)}
                  menuPlacement="auto"
                />)}
              {this.props.fieldsConfiguration?.modelYear && this.props.fieldsConfiguration.modelYear.permission !== permissions.hidden && (
                <Field
                  component={InputNumber}
                  id="modelYearOrder"
                  name="modelYear"
                  controlLabel={t(`${tKey}MODEL_YEAR`)}
                  placeholder={t(`${tKey}MODEL_YEAR`)}
                  maxLength={modelLength.maxLength}
                  disabled={readOnlyFields}
                  validate={this.required}
                />)}
              {this.props.fieldsConfiguration?.colorId && this.props.fieldsConfiguration.colorId.permission !== permissions.hidden && (
                <Field
                  component={InputSelect}
                  id="colorIdOrder"
                  name="colorId"
                  controlLabel={t(`${tKey}COLOR`)}
                  placeholder={t(`${tKey}COLOR`)}
                  valueKey="id"
                  labelKey="value" options={colorCombo}
                  disabled={colorCombo.length === 0 || readOnlyFields }
                  validate={this.required}
                />)}
              {this.props.fieldsConfiguration?.tapestryId && this.props.fieldsConfiguration.tapestryId.permission !== permissions.hidden && (
                <Field
                  component={InputSelect}
                  id="tapestryIdOrder"
                  name="tapestryId"
                  controlLabel={t(`${tKey}TAPESTRY`)}
                  placeholder={t(`${tKey}TAPESTRY`)}
                  valueKey="id"
                  labelKey="value"
                  options={tapestryCombo}
                  disabled={tapestryCombo.length === 0 || readOnlyFields}
                  validate={this.required}
                />)}
              <Field
                component={InputText}
                id="modelOrder"
                name="model"
                controlLabel={t(`${tKey}MODEL`)}
                placeholder={t(`${tKey}MODEL`)}
                disabled={readOnlyFields || (this.props.fieldsConfiguration?.carlineId && this.props.fieldsConfiguration.carlineId.permission !== permissions.hidden)}
                validate={this.required}
              />
              {this.props.fieldsConfiguration?.color && this.props.fieldsConfiguration.color.permission !== permissions.hidden && (
                <Field
                  component={InputText}
                  id="colorOrder"
                  name="color"
                  controlLabel={t(`${tKey}COLOR`)}
                  placeholder={t(`${tKey}COLOR`)}
                  disabled={readOnlyFields}
                  validate={this.required}
                />)}
              {purchaseOrderExetendedMode && (
                <SaleRequestFields
                  t={t}
                  readOnlyFields={readOnlyFields}
                  purchaseTypeVnCombo={purchaseTypeVnCombo}
                  entityTransferCombo={entityTransferCombo}
                  validateRequired={true}
                  order={order}
                  className="sale-request-fields col-sm-4"
                  purchaseTypeChangeHandler={(value) => this.setState({ purchaseType: value })}
                />
              )}
              {purchaseOrderExetendedMode && this.state.purchaseType === purchaseTypesVn.transfer && (
                <div className="clearfix" />)}
              {this.props.fieldsConfiguration?.tapestry && this.props.fieldsConfiguration.tapestry.permission !== permissions.hidden && (
                <Field
                  component={InputText}
                  id="tapestryOrder"
                  name="tapestry"
                  controlLabel={t(`${tKey}TAPESTRY`)}
                  placeholder={t(`${tKey}TAPESTRY`)}
                  disabled={readOnlyFields}
                />)}
              {purchaseOrderExetendedMode && this.state.purchaseType === purchaseTypesVn.normal && (
                <div className="clearfix" />)}
              {this.props.fieldsConfiguration?.comercialCode && this.props.fieldsConfiguration.comercialCode.permission !== permissions.hidden && (
                <Field
                  component={InputText}
                  id="comercialCodeOrder"
                  name="comercialCode"
                  controlLabel={t(`${tKey}COMMERCIAL_CODE`)}
                  placeholder={t(`${tKey}COMMERCIAL_CODE`)}
                  disabled={readOnlyFields}
                />)}
              <Field
                component={InputSelect}
                id="fuelIdOrder"
                name="fuelId"
                controlLabel={t(`${tKey}FUEL`)}
                placeholder={t(`${tKey}FUEL`)}
                options={fuelCombo}
                valueKey="id"
                labelKey="value"
                disabled={readOnlyFields}
              />
            </Row>

          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} className="flexInLine al-C">
              <Button id="btn_save_Order" className="_Btn new" type="submit">{t('GLOBAL.BUTTONS.SAVE')}</Button>
            </Col>
          </Modal.Footer>
        </Form>
      </Modal>
    )
  }
}

const validate = (values, props) => {
  const errors = {}
  if (values) {
    if (!values.brandId || values.brandId === '') {
      errors.brandId = props.t('DOSSIER_COMPONENTS.VALIDATIONS.VEHICLE_BRAND_MANDATORY')
    }
    if (!values.model || values.model === '') {
      errors.model = props.t('DOSSIER_COMPONENTS.VALIDATIONS.VEHICLE_MODEL_MANDATORY')
    }
    if (!values.color || values.color === '') {
      errors.color = props.t('DOSSIER_COMPONENTS.VALIDATIONS.VEHICLE_COLOR_MANDATORY')
    }
    if (!values.colorId || values.colorId === '') {
      errors.colorId = props.t('DOSSIER_COMPONENTS.VALIDATIONS.VEHICLE_COLOR_MANDATORY')
    }
    if (!values.tapestryId || values.tapestryId === '') {
      errors.tapestryId = props.t('DOSSIER_COMPONENTS.VALIDATIONS.VEHICLE_TAPESTRY_MANDATORY')
    }
    if (props.fieldsConfiguration?.modelId.permission &&
      props.fieldsConfiguration?.modelId.permission !== permissions.hidden &&
      (!values.modelId || values.modelId === '')) {
      errors.modelId = props.t('DOSSIER_COMPONENTS.VALIDATIONS.VEHICLE_MODEL_YEAR_MANDATORY')
    }

    if (props.fieldsConfiguration?.modelYear.permission &&
      props.fieldsConfiguration?.modelYear.permission !== permissions.hidden &&
      (!values.modelYear || !values.modelYear.match(commonRegExp.is4DigitYear))) {
      errors.modelYear = props.t('GLOBAL.FORMS.INVALID_STRING')
    }
  }
  return errors
}

export default reduxForm({
  form: 'order',
  validate
})(OrderModal)
